/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} English_Level_LabelInputs */

const en_english_level_label = /** @type {(inputs: English_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English level`)
};

const de_english_level_label = /** @type {(inputs: English_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englischkenntnisse`)
};

/**
* | output |
* | --- |
* | "English level" |
*
* @param {English_Level_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const english_level_label = /** @type {((inputs?: English_Level_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<English_Level_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_english_level_label(inputs)
	return en_english_level_label(inputs)
});